import React from 'react'
import { ParticipantsList } from './list/page'

export const Ramadan2026ParticipantsPage = () => {
  return <ParticipantsList />
}
